import moment from "moment-timezone";
import uuid from "node-uuid";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {OverlayTrigger, Popover} from "react-bootstrap";
import DayPicker, {DateUtils} from "react-day-picker";
import LocaleUtils from "react-day-picker/moment";

import {noop} from "utils";

export default class DatePicker extends Component {
  static contextTypes = {
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
    }),
  }
  static defaultProps = {
    input: false,
    onDayClick: noop,
    popover: false,
  }
  static propTypes = {
    children: PropTypes.node,
    linkClassName: PropTypes.string,
    onDayClick: PropTypes.func,
    popover: PropTypes.bool,
    value: PropTypes.instanceOf(Date),
  }

  handleOnDayClick = (evt, day, modifiers) => {
    const {onDayClick, popover} = this.props;
    if (popover && this.overlayTriggerEl) {
      this.overlayTriggerEl.setState({
        show: false,
      });
    }
    onDayClick(evt, day, modifiers);
  }

  renderDayPicker() {
    const {params: {date}} = this.context;
    const {value} = this.props;

    const currentDate = value || moment(date).toDate();
    const props = {
      ...this.props,
      onDayClick: this.handleOnDayClick,
    };

    return (
      <DayPicker
        initialMonth={currentDate}
        locale="en"
        localeUtils={LocaleUtils}
        selectedDays={day => DateUtils.isSameDay(currentDate, day)}
        {...props} />
    );
  }

  renderPopover() {
    const {children, linkClassName} = this.props;
    const popover = (
      <Popover id={`date-picker-${uuid.v4()}`}>
        {this.renderDayPicker()}
      </Popover>
    );
    return (
      <OverlayTrigger
        overlay={popover}
        placement="bottom"
        ref={el => this.overlayTriggerEl = el}
        rootClose
        trigger="click">
        <a
          className={linkClassName}
          href="#"
          onClick={evt => evt.preventDefault()}>
          {children}
        </a>
      </OverlayTrigger>
    );
  }

  render() {
    const {popover} = this.props;
    if (popover) {
      return this.renderPopover();
    }
    return this.renderDayPicker();
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DatePicker.js
 **/